import $ from 'jquery';

$(()=>{
    $(".generic__links__inner").children("span[class=divider]:last").remove();
});
